import { useTheme } from "../../contexts/ThemeContext";

export default function SidebarItem({ icon, label, active, onClick, collapsed, badge }) {
  const { C } = useTheme();
  const showBadge = typeof badge === "number" && badge > 0;
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: collapsed ? 0 : 12,
        justifyContent: collapsed ? "center" : "flex-start",
        padding: collapsed ? "12px" : "11px 16px",
        borderRadius: 10,
        border: "none",
        cursor: "pointer",
        width: "100%",
        background: active ? C.accentDim : "transparent",
        color: active ? C.accent : C.textMuted,
        fontSize: 13.5,
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        fontFamily: "'DM Sans', sans-serif",
        position: "relative",
      }}
    >
      <span style={{ fontSize: 18, width: 22, textAlign: "center", position: "relative" }}>
        {icon}
        {showBadge && collapsed && (
          <span
            style={{
              position: "absolute",
              top: -6,
              right: -10,
              minWidth: 16,
              height: 16,
              padding: "0 4px",
              borderRadius: 8,
              background: C.red || "#e53935",
              color: "#fff",
              fontSize: 9,
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {badge > 99 ? "99+" : badge}
          </span>
        )}
      </span>
      {!collapsed && (
        <>
          <span style={{ flex: 1, textAlign: "left" }}>{label}</span>
          {showBadge && (
            <span
              style={{
                minWidth: 20,
                height: 18,
                padding: "0 6px",
                borderRadius: 9,
                background: C.red || "#e53935",
                color: "#fff",
                fontSize: 10,
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {badge > 99 ? "99+" : badge}
            </span>
          )}
        </>
      )}
    </button>
  );
}
